const toJSON = data => data.json();

export { toJSON };



// WEBPACK FOOTER //
// ./src/utils.js